(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-halloween-last-call-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.querySelector('.cc-halloween-popup');
  if (!popup || popup.dataset.initialized === 'true') return;
  popup.dataset.initialized = 'true';

  const closeButton = popup.querySelector('.cc-halloween-popup__close');
  const storageKey = 'cc-halloween-last-call-seen';
  const newsletterFormIds = new Set(['YfcwJp']);
  const cookieSelectors = ['#shopify-pc__banner', '#shopify-pc__prefs__dialog'];
  const activeNewsletterForms = new Set();
  let cookieStepDone = false;
  let cookieUiSeen = false;
  let newsletterWaiting = false;
  let newsletterCompleted = false;
  let newsletterCompletionTimer = null;
  let newsletterFallbackTimer = null;
  let popupTimer = null;
  let observer = null;

  const visibleCookieUi = () => cookieSelectors.some((selector) => {
    const element = document.querySelector(selector);
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  });

  const openPopup = () => {
    try {
      if (window.sessionStorage.getItem(storageKey)) return;
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {}
    if (!popup.open) popup.showModal();
    if (observer) observer.disconnect();
  };

  const scheduleHalloweenPopup = () => {
    if (!cookieStepDone || activeNewsletterForms.size > 0 || popupTimer || popup.open) return;
    if (!newsletterCompleted) return;

    popupTimer = window.setTimeout(() => {
      popupTimer = null;
      if (!visibleCookieUi() && activeNewsletterForms.size === 0) openPopup();
    }, 1500);
  };

  const waitForNewsletter = () => {
    if (!cookieStepDone || newsletterWaiting || newsletterCompleted || visibleCookieUi()) return;
    newsletterWaiting = true;
    newsletterFallbackTimer = window.setTimeout(() => {
      newsletterFallbackTimer = null;
      newsletterCompleted = true;
      scheduleHalloweenPopup();
    }, 18000);
  };

  const completeCookieStep = () => {
    if (cookieStepDone) return;
    cookieStepDone = true;
    if (newsletterCompleted) {
      scheduleHalloweenPopup();
    } else {
      waitForNewsletter();
    }
  };

  const watchCookieUi = () => {
    if (observer || !document.documentElement) return;
    observer = new MutationObserver(() => {
      if (visibleCookieUi()) {
        cookieUiSeen = true;
        cookieStepDone = false;
        if (popupTimer) {
          window.clearTimeout(popupTimer);
          popupTimer = null;
        }
        if (newsletterFallbackTimer) {
          window.clearTimeout(newsletterFallbackTimer);
          newsletterFallbackTimer = null;
          newsletterWaiting = false;
        }
      } else if (cookieUiSeen) {
        completeCookieStep();
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'open', 'style'],
      childList: true,
      subtree: true
    });
  };

  closeButton.addEventListener('click', () => popup.close());

  document.addEventListener('visitorConsentCollected', () => {
    if (visibleCookieUi()) {
      cookieUiSeen = true;
      cookieStepDone = false;
      if (popupTimer) {
        window.clearTimeout(popupTimer);
        popupTimer = null;
      }
      if (newsletterFallbackTimer) {
        window.clearTimeout(newsletterFallbackTimer);
        newsletterFallbackTimer = null;
        newsletterWaiting = false;
      }
      watchCookieUi();
    } else {
      completeCookieStep();
    }
  });

  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail || {};
    const formId = String(detail.formId || detail.formID || '');
    if (!newsletterFormIds.has(formId)) return;

    if (detail.type === 'open') {
      if (newsletterFallbackTimer) {
        window.clearTimeout(newsletterFallbackTimer);
        newsletterFallbackTimer = null;
      }
      newsletterWaiting = true;
      activeNewsletterForms.add(formId);
      if (popupTimer) {
        window.clearTimeout(popupTimer);
        popupTimer = null;
      }
      if (popup.open) {
        popup.close();
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {}
      }
    }

    if (detail.type === 'submit') {
      if (newsletterCompletionTimer) window.clearTimeout(newsletterCompletionTimer);
      newsletterCompletionTimer = window.setTimeout(() => {
        newsletterCompletionTimer = null;
        activeNewsletterForms.delete(formId);
        newsletterCompleted = true;
        scheduleHalloweenPopup();
      }, 2200);
    }

    if (detail.type === 'close') {
      if (newsletterFallbackTimer) {
        window.clearTimeout(newsletterFallbackTimer);
        newsletterFallbackTimer = null;
      }
      activeNewsletterForms.delete(formId);
      newsletterCompleted = true;
      if (newsletterCompletionTimer) {
        window.clearTimeout(newsletterCompletionTimer);
        newsletterCompletionTimer = null;
      }
      scheduleHalloweenPopup();
    }
  });

  watchCookieUi();

  const waitForCookieStep = (attempt = 0) => {
    if (visibleCookieUi()) {
      cookieUiSeen = true;
      return;
    }

    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.shouldShowBanner === 'function') {
      if (!privacy.shouldShowBanner()) {
        completeCookieStep();
      } else {
        window.setTimeout(() => waitForCookieStep(attempt + 1), 250);
      }
      return;
    }

    if (attempt < 30) {
      window.setTimeout(() => waitForCookieStep(attempt + 1), 200);
    } else {
      completeCookieStep();
    }
  };

  waitForCookieStep();
})();
  } catch(e) { console.error(e); }
})();

})();
